const theme = {
  admin: {
    font: {
      fontFamily: {
        Roboto: "Roboto",
        lato: "Lato",
      },
      fontSize: {
        lg: "18px",
        xl: "20px",
        xxl: "25px",
        xxxl: "30px",
        md: "15px",
        rg: "14px",
        sm: "13px",
        xsm: "12px",
        xxsm: "11px",
        xxxsm: "10px",
      },
      fontWeight: {
        thin: "100",
        light: "300",
        regular: "400",
        medium: "500",
        semiBold: "600",
        bold: "700",
        black: "900",
      },
      lineHeight: {
        lg: "24px",
        xl: "28px",
        xxl: "32px",
        xxxl: "36px",
        md: "20px",
        rg: "18px",
        sm: "18px",
        xsm: "16px",
        xxsm: "16px",
        xxxsm: "14px",
      },
    },
    color: {
      color1: "#333",
      color2: "#4f4f4f",
      color3: "#828282",
      color4: "#777",
      color5: "#bdbdbd",
      color6: "#fcfcfc",
      color7: "#fff",
      color8: "#012d5a",
      color9: "#005aa3",
      color10: "#2AC940",
      color11: "#F01102",
      color12: "#E0E0E0",
      color13: "#F7F8F9",
      color14: "#F0F3F4",
      color15: "#000000",
      color16: "#F2F2F2",
    },
    button: {
      solid: {
        primary: {
          bgColor: "#ED141F",
          HoverBgColor: "#ED141F",
          color: "#fff",
          hoverColor: "#fff",
        },
        sucess: {
          bgColor: "green",
          HoverBgColor: "#ED141F",
          color: "#fff",
          hoverColor: "#fff",
        },
        disabled: {
          bgColor: "#bdbdbd",
          color: "#fff",
        },
      },
      outline: {
        primary: {
          bgColor: "#fff",
          color: "#000000",
          HoverbgColor: "#FB8D37",
          HoverColor: "#fff",
        },
        disabled: {
          bgColor: "#fff",
          color: "#bdbdbd",
        },
      },
      fontSize: {
        xl: "16px",
        lg: "14px",
        md: "13px",
        rg: "12px",
        sm: "10px",
      },
      height: {
        xl: "42px",
        lg: "40px",
        md: "36px",
        rg: "30px",
        sm: "20px",
      },
      rounded: {
        xl: "4px",
        lg: "4px",
        md: "4px",
        rg: "3px",
        sm: "2px",
      },
    },
  },
};

export default theme;

// old theme

// const theme = {
//   admin: {
//     font: {
//       fontFamily: {
//         Roboto: "Roboto",
//         lato: "Lato",
//       },
//       fontSize: {
//         lg: "20px",
//         xl: "25px",
//         xxl: "30px",
//         xxxl: "35px",
//         md: "18px",
//         rg: "15px",
//         sm: "14px",
//         xsm: "13px",
//         xxsm: "12px",
//         xxxsm: "11px",
//       },
//       fontWeight: {
//         thin: "100",
//         light: "300",
//         regular: "400",
//         medium: "500",
//         semiBold: "600",
//         bold: "700",
//         black: "900",
//       },
//       lineHeight: {
//         lg: "28px",
//         xl: "32px",
//         xxl: "36px",
//         xxxl: "42px",
//         md: "26px",
//         rg: "22px",
//         sm: "20px",
//         xsm: "18px",
//         xxsm: "16px",
//         xxxsm: "16px",
//       },
//     },
//     color: {
//       color1: "#333",
//       color2: "#4f4f4f",
//       color3: "#828282",
//       color4: "#777",
//       color5: "#bdbdbd",
//       color6: "#fcfcfc",
//       color7: "#fff",
//       color15: "#012d5a",
//       color9: "#005aa3",
//       color10: "#2AC940",
//       color11: "#F01102",
//       color12: "#E0E0E0",
//       color13: "#F7F8F9",
//       color14: "#F0F3F4",
//     },
//     button: {
//       solid: {
//         primary: {
//           bgColor: "#005AA3",
//           color: "#fff",
//         },
//       },
//       outline: {
//         primary: {
//           bgColor: "#fff",
//           color: "#005AA3",
//         },
//       },
//       fontSize: {
//         xl: "18px",
//         lg: "15px",
//         md: "14px",
//         rg: "13px",
//         sm: "12px",
//       },
//       height: {
//         xl: "50px",
//         lg: "50px",
//         md: "40px",
//         rg: "30px",
//         sm: "20px",
//       },
//       rounded: {
//         xl: "8px",
//         lg: "5px",
//         md: "4px",
//         rg: "3px",
//         sm: "2px",
//       },
//     },
//   },
// };
